module.exports = __webpack_public_path__ + "img/HMD.f1fde7f2.svg";